var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShipOutline = function SvgShipOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 9.152V3.057a.954.954 0 0 1 .95-.952H7.6V.2h3.8v1.905h4.75a.949.949 0 0 1 .95.952v6.095l1.032.31a.95.95 0 0 1 .648 1.144l-1.44 5.779a4.731 4.731 0 0 1-1.807-.26l1.187-5.097L9.5 8.771l-7.22 2.257 1.188 5.097a4.73 4.73 0 0 1-1.807.26l-1.44-5.78a.955.955 0 0 1 .647-1.142l1.032-.31Zm1.9-.571 5.7-1.714 5.7 1.714V4.009H3.8v4.572Zm-1.9 9.714a5.67 5.67 0 0 0 3.8-1.455 5.67 5.67 0 0 0 3.8 1.455 5.67 5.67 0 0 0 3.8-1.455 5.67 5.67 0 0 0 3.8 1.455H19V20.2h-1.9a7.55 7.55 0 0 1-3.8-1.02 7.55 7.55 0 0 1-3.8 1.02 7.55 7.55 0 0 1-3.8-1.02 7.55 7.55 0 0 1-3.8 1.02H0v-1.905h1.9Z",
    fill: "#E96358"
  })));
};

export default SvgShipOutline;